// extracted by mini-css-extract-plugin
module.exports = {"space":"LayoutWeb_space__2Ee92","appbar":"LayoutWeb_appbar__ukR-E","btn":"LayoutWeb_btn__1rftM","contents":"LayoutWeb_contents__1RaKV","btn-color":"LayoutWeb_btn-color__gUDE9"};